import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { Img } from '@/components/blocks/MaterialImage';
import {
	AccountSummaryLinkToCardButtonSX,
	AccountSummaryLinkToCardDescriptionSX,
	AccountSummaryLinkToCardFrameSX,
	AccountSummaryLinkToCardImgSX,
	AccountSummaryLinkToCardTitleSX,
} from '@/components/content/Account/styles/summaryLinkToCard';

interface AccountSummaryLinkToCardProps {
	type: 'rewards' | 'dpvale';
	title: string;
	description: string;
	img: string;
	onLinkToCard: () => void;
}

export const AccountSummaryLinkToCard: React.FC<AccountSummaryLinkToCardProps> = ({
	type,
	title,
	description,
	img,
	onLinkToCard,
}) => (
	<Stack direction={{ xs: 'row', md: 'row' }} sx={AccountSummaryLinkToCardFrameSX}>
		<Stack direction="row" spacing={3}>
			<Img src={img} alt={'Club Dp'} sx={AccountSummaryLinkToCardImgSX(type)} />
			<Stack spacing={0.2}>
				<Typography component={'h3'} sx={AccountSummaryLinkToCardTitleSX}>
					{title}
				</Typography>
				<Typography sx={AccountSummaryLinkToCardDescriptionSX}>{description}</Typography>
			</Stack>
		</Stack>
		<Box sx={{ display: 'grid', placeItems: 'center' }}>
			<ButtonBase disableRipple sx={AccountSummaryLinkToCardButtonSX} onClick={onLinkToCard}>
				{'Vincular tarjeta'}
			</ButtonBase>
		</Box>
	</Stack>
);
